import React from 'react';
import ReactDOM from 'react-dom/client';
import './config/Pagestyle.css'
import App from './App';
import './index.css';
import KalravProvider from './contexts/KalravProvider';
import { initGA } from './lib/analytics';
import { preloadFirebaseMessagingServiceWorker } from './utils/pushNotifications';

initGA();

if (typeof navigator !== "undefined" && navigator.serviceWorker) {
  preloadFirebaseMessagingServiceWorker().catch(() => {});
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<>
    {/* <KalravProvider> */}
        <App />
    {/* </KalravProvider> */}
</>
);


